const KEY = "pm.theme";
export type Theme = "light" | "dark" | "system";

export function getTheme(): Theme {
  try { return (localStorage.getItem(KEY) as Theme) || "system"; } catch { return "system"; }
}

export function applyTheme(t: Theme = getTheme()) {
  const dark = t === "dark" || (t === "system" && matchMedia("(prefers-color-scheme: dark)").matches);
  document.documentElement.dataset.theme = dark ? "dark" : "light";
  try { localStorage.setItem(KEY, t); } catch { /* ignore */ }
}
